import styled, { css } from 'styled-components';

export const Body = styled.div`
	width: 100%;
	height: max-content;
	padding: 32px;
	border-radius: 16px;

	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	color: ${({ theme }) => theme.colors.uplus.bg80_darken};
	//color: ${({ theme }) => theme.colors.gray.gray80_text};

	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 16px;
`;

export const BodyTitleGroup = styled.div`
	width: 100%;
	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 8px;
`;

export const BodyTitle = styled.h3`
	width: 100%;

	${({ theme }) => theme.typo.title.h3};
	text-align: left;
`;

export const BodyDesc = styled.p`
	width: 100%;
	text-align: left;

	${({ theme }) => theme.typo.body.p_bold};
	color: ${({ theme }) => theme.colors.gray.gray80_text};
`;

export const InputForm = styled.div`
	width: 100%;
	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 8px;
`;

export const RememberBox = styled.div<{ checked: boolean }>`
	width: 100%;
	padding-bottom: 16px;

	user-select: none;

	& > label {
		color: ${({ theme }) => theme.colors.gray.gray30};
		${({ theme }) => theme.typo.body.p_bold};
	}

	${({ checked, theme }) =>
		checked
			? css`
					& svg {
						fill: ${theme.colors.uplus.primary50_key};
					}
			  `
			: css`
					& svg {
						fill: ${theme.colors.gray.gray15};
					}
			  `}
`;

export const BodyFooter = styled.div`
	width: 100%;

	${({ theme }) => theme.common.flexStart};
	flex-direction: column;
	gap: 8px;

	& > a {
		width: 100%;
	}
`;

export const ForgotText = styled.p`
	text-align: center;
	text-decoration: underline;
	color: ${({ theme }) => theme.colors.gray.gray30};
	${({ theme }) => theme.typo.body.p_bold};
	user-select: none;
	cursor: pointer;
`;
